// extracted by mini-css-extract-plugin
module.exports = {"broadcastContainer":"BroadcastScreen-module__broadcastContainer___3JKip","instructions":"BroadcastScreen-module__instructions___1dUEY","li":"BroadcastScreen-module__li___2_ZG4"};